import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { WorkflowStatus } from "@webapp/okrs/goals/models/goal-workflow.models";
import { UiLabelColor } from "@webapp/ui/label/models/label.models";

const statusTextKeys: Record<WorkflowStatus, string> = {
  approved: "approved",
  notEnoughReviewers: "needsReviewers",
  inReview: "in_review",
  draft: "draft",
};

const statusColors: Record<WorkflowStatus, UiLabelColor> = {
  approved: "green",
  notEnoughReviewers: "yellow",
  inReview: "blue",
  draft: "grey",
};

@Component({
  selector: "goal-workflow-status-label",
  template: `<ui-label [uiColor]="statusColor">{{ statusTextKey | localize }}</ui-label>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GoalWorkflowStatusLabelComponent {
  @Input()
  public status: WorkflowStatus;

  public get statusColor(): UiLabelColor | undefined {
    return this.status ? statusColors[this.status] : undefined;
  }

  public get statusTextKey(): string | undefined {
    return this.status ? statusTextKeys[this.status] : undefined;
  }
}
